import {fadeIn, fadeOut} from "./utilities/fade";

function buildChildrenBackLink(wrapper) {
    if (!wrapper.querySelector('.mobileMenu__backLink')) {
        let childrenBackLink = document.createElement("a");
        childrenBackLink.classList.add("mobileMenu__backLink");
        childrenBackLink.innerText = GLOBALS.tc.back;

        childrenBackLink.addEventListener("click", function () {
            let closestOpenItem = childrenBackLink.closest(".hasChildren.is-open");
            if (closestOpenItem) {
                closestOpenItem.classList.remove("is-open");
                closestOpenItem.querySelector("ul").scrollTop = 0;
                closestOpenItem.querySelector("ul").style.overflow = "";
            }
        });

        wrapper.prepend(childrenBackLink);
    }
}

function buildChildrenHeader(wrapper, childrenLink) {
    if (!wrapper.querySelector('.mobileMenu__subHeader')) {
        let childrenHeader = document.createElement("a");
        childrenHeader.classList.add("mobileMenu__subHeader");
        childrenHeader.innerText = childrenLink.innerText;
        if (childrenLink.tagName === 'A') {
            childrenHeader.href = childrenLink.href;
        }
        wrapper.prepend(childrenHeader);
    }
}

function addClickEventMobileMenuLink(link) {
    let hasChildren = false;
    let childrenLink = false;
    let parent = link.closest("li");
    let childrenList = false;

    for (let children of parent.children) {
        if (children.tagName === "UL") {
            hasChildren = true;
            childrenList = children;
        }
        if (children.tagName === 'A' || children.tagName === 'SPAN') {
            childrenLink = children;
        }
    }

    if (hasChildren) {
        if (!childrenLink.hasClickEventListener) {
            childrenLink.addEventListener("click", function (e) {
                e.preventDefault();

                let closestLi = childrenLink.closest('li');
                let closestUl = childrenLink.closest("ul");

                document.querySelectorAll(".hasChildren.is-open").forEach(openLi => {
                    if (openLi !== closestLi) {
                        openLi.classList.remove("is-open");
                        openLi.querySelector("a").classList.remove("is-active");
                        if (openLi.querySelector("ul")) {
                            openLi.querySelector("ul").style.overflow = "";
                        }
                    }
                });

                if (!closestLi.classList.contains("is-open")) {
                    closestLi.classList.add("is-open");
                    childrenLink.classList.add("is-active");
                    closestUl.style.overflow = "hidden";
                    closestUl.style.height = "auto";
                }
            });
            childrenLink.hasClickEventListener = true;
        }

        parent.classList.add("hasChildren");

        if (childrenList) {
            buildChildrenHeader(childrenList, childrenLink);
            buildChildrenBackLink(childrenList);
        }
    }
}
function activateFirstLinkIfNoneActive(menu) {
    const firstLink = menu.querySelector('a');
    const isAnyLinkActive = menu.querySelector('.is-active');

    if (!isAnyLinkActive && window.innerWidth > 767) {
        if (firstLink) {
            firstLink.classList.add('is-active');
            firstLink.closest('li').classList.add('is-open');
        }
    }
}

export function buildMobileMenu(menu) {
    if (menu) {
        for(let menuNavigation of menu.querySelectorAll(".mobileMenu__navigation")){
            for (let link of menuNavigation.querySelectorAll('a')) {
                addClickEventMobileMenuLink(link);
            }
            for (let activeUl of menuNavigation.querySelectorAll('.is-active,.is-active-tree')) {
                activeUl.classList.add("is-open");
            }
        }
        activateFirstLinkIfNoneActive(menu);
    }
}

export function showMobileMenu(menu, overlay, toggle) {
    fadeIn(overlay, 200, "linear", function () {
        menu.classList.add("is-open");
        toggle.classList.add("is-active");
        toggle.setAttribute("aria-expanded", "true");
        document.body.classList.add("is-mobilemenuopen");

        // Focus management for accessibility
        if (!menu.hasAttribute('tabindex')) {
            menu.setAttribute('tabindex', '-1');
        }
        menu.focus();
    });
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("is-open");
    toggle.classList.remove("is-active");
    toggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("is-mobilemenuopen");
    fadeOut(overlay);

    // Return focus to toggle button for accessibility
    toggle.focus();
}
